import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormTemplateAPI } from '../../../api/FormTemplateAPI';
import styles from '../../../styles/modules/RegistrationSetup.module.css';
import { getFieldName, getFieldsByType, getFormattedDate } from './RegistrationHelper';
import CustomContainerLoader from '../../CustomComponents/CustomContainerLoader/CustomContainerLoader';
import dayjs from 'dayjs';
import * as Yup from 'yup';
import { isGuest } from '../../../util/UserRoles';



const FormInfo = ({ setFieldErrors, formTemplateId, formData, setFormData, child, setYupObject, fieldErrors = {}, isPlayer }) => {
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const userInfo = useSelector((store) => store.user.userInfo);
    const [formFieldsWithSection, setFormFieldsWithSection] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getAllFormFieldsWithSection = async () => {
        try {
            setIsLoading(true)
            const response = await FormTemplateAPI.getAllFormFieldsWithSection(selectedClub.clubId, formTemplateId);
            //console.log("Form Fields with Section Response: ", response);
            setFormFieldsWithSection(response.Data);
            if (Object.keys(formData).length === 0) {
                setInitialValue(response.Data);
            }
            getRequiredFields(response.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const setInitialValue = (formFields) => {
        let initialValue = {};
        formFields?.forEach((fs) => {
            fs.formFields.forEach((ff) => {
                const fieldName = getFieldName(ff);
                // if (ff.isRequired) {
                if (child.childrenId && !ff.isRemovable && (fieldName === 'first_name' || fieldName === 'last_name' || fieldName === 'date_of_birth' || fieldName === 'relation')) {
                    if (fieldName === 'first_name') {
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]: child.firstName
                        };
                    } else if (fieldName === 'last_name') {
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]: child.lastName
                        };
                    } else if (fieldName === 'date_of_birth') {
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]: child.dob
                        };
                    } else if (fieldName === 'relation' && !isPlayer) {
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]: child.relationshipType
                        };
                    } else if (fieldName === 'relation' && isPlayer) {
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]: null
                        };
                    }
                } else {
                    if (!isGuest(userInfo) && fieldName === 'club_name') {
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]:selectedClub.clubName
                        };
                    } else if(fieldName === 'email'){
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]:userInfo.email
                        };
                    }else if(fieldName === 'mobile_number'){
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]:userInfo.phone
                        };
                    }else{
                        initialValue[fs.sectionId] = {
                            ...initialValue[fs.sectionId],
                            [fieldName]: ff.type === 'date' ? getFormattedDate(dayjs(new Date())) : null
                        };
                    }
                }

                // }
            })
        })
      // console.log(initialValue);
       
        setFormData(initialValue);
    };


    const getRequiredFields = (formFields) => {
        let initialState = {};
       // console.log("initial state", initialState);
        formFields?.forEach((fs) => {
            fs.formFields.forEach((ff) => {
                const fieldName = getFieldName(ff);
                if (!fs.isRemovable && fieldName === 'relation' && isPlayer) {

                } else if (ff.isRequired && ff.isShow) {
                    initialState[fs.sectionId] = {
                        ...initialState[fs.sectionId],
                        [fieldName]: ff.type === 'date' ? getFormattedDate(dayjs(new Date())) : ''
                    };
                }
            })
        });

        const yupObj = Yup.object(
            Object.entries(initialState).reduce((acc, [sectionKey, fields]) => {
                acc[sectionKey] = Yup.object(
                    Object.keys(fields).reduce((fieldAcc, fieldKey) => {
                        fieldAcc[fieldKey] = Yup.string().required(`${fieldKey?.replaceAll("_", " ")} is required`);
                        return fieldAcc;
                    }, {})
                );
                return acc;
            }, {})
        );
        setYupObject(yupObj);
    };



    useEffect(() => {
        if (selectedClub.clubId) {
            getAllFormFieldsWithSection();
        }
    }, [selectedClub.clubId]);

    const handleCollectData = useCallback((event, sectionId) => {
        const { name, value } = event.target;
        setFormData(prev => ({
            ...prev,
            [sectionId]: {
                ...(prev[sectionId] || {}),
                [name]: value
            }
        }));
    }, []);


    if (isLoading) {
        return <CustomContainerLoader />
    }

    const isChildrenFieldDisabled = (isRemovable, field) => {
        const fieldName = getFieldName(field);
        if(isDisable(fieldName)){
            return true;
        }
        if (!isRemovable && child.childrenId && (fieldName === 'first_name' || fieldName === 'last_name' || fieldName === 'date_of_birth' || fieldName === 'relation')) {
            return true;
        } else {
            return false
        }
    }

    const isDisable = (fieldName)=>{
       return !isGuest(userInfo) && fieldName == 'club_name';
    } 

    return (
        <div>
            {formFieldsWithSection?.map((section, index) =>
                <div key={index} className={styles['form_overview_sections']}>
                    <h1>{section?.sectionName}</h1>
                    <div className={styles['form_overview_sections_fields']}>
                        {
                            section?.formFields?.filter(item => isPlayer ? (item.name !== 'Relation' || item.isRemovable) : item).map((field, index) =>
                                (field.type !== 'checkbox' && field.type !== 'radio' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field, handleCollectData, formData[section?.sectionId], isChildrenFieldDisabled(field.isRemovable,
                                                field), fieldErrors[section?.sectionId])
                                        }

                                    </React.Fragment>
                                )

                            )
                        }
                    </div>
                    <div className={styles['form_overview_sections_radio_fields']}>
                        {
                            section?.formFields?.map((field, index) =>
                                (field.type === 'radio' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field, handleCollectData, formData[section?.sectionId], isDisable(getFieldName(field)), fieldErrors[section?.sectionId])
                                        }
                                    </React.Fragment>
                                )

                            )
                        }
                    </div>
                    <div className={styles['form_overview_sections_checkbox_fields']}>

                        {
                            section?.formFields?.map((field, index) =>
                                (field.type === 'checkbox' && field.isShow) &&
                                (
                                    <React.Fragment key={index}>
                                        {
                                            getFieldsByType(field, handleCollectData, formData[section?.sectionId], isDisable(getFieldName(field)), fieldErrors[section?.sectionId])
                                        }
                                        <span style={{ height: 5 }}></span>
                                    </React.Fragment>
                                )

                            )
                        }
                    </div>
                </div>
            )}
        </div>
    )
}

export default FormInfo